// extracted by mini-css-extract-plugin
export default {"colorSuccess":"vp_yxJHe","colorWarning":"vp_FI4HG","colorError":"vp_UlDQb","colorBase":"vp_mAi0Y"};